const userSearchFields = (searchFieldValues, entityList, roleList) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "firstName",
                        label: "First Name",
                        type: "text",
                        value: searchFieldValues.firstName.value,
                    },
                    {
                        id: "lastName",
                        label: "Last Name",
                        type: "text",
                        value: searchFieldValues.lastName.value,
                    },
                    {
                        id: "email",
                        label: "Email",
                        type: "text",
                        value: searchFieldValues.email.value,
                    }
                ]
            },
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "entityId",
                        label: "Entity",
                        type: "dropdown",
                        value: searchFieldValues.entityId.value,
                        data: entityList,
                        validator: () => { }
                    },
                    {
                        id: "roleId",
                        label: "Role",
                        type: "dropdown",
                        value: searchFieldValues.roleId.value,
                        data: roleList,
                        validator: () => { }
                    }
                ]
            }
        ]
    }
};

export {
    userSearchFields
}